<template>
  <PageLayoutWrapper
    page="programs/index"
    :props="{ ...$props }"
  >
    <DefaultProgramsView :page-content="pageContent" />
  </PageLayoutWrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import pageLayout from '@/mixins/pageLayoutMixin'
import DefaultProgramsView from '@/components/DefaultProgramsView'
import { metaTags, metaTitle } from '@/utils/meta'
import useMeta from '@/composables/useMeta'
export default {
  components: {
    DefaultProgramsView,
    PageLayoutWrapper,
  },
  mixins: [pageLayout],
  setup() {
    const { catalogWideMetaTitle } = useMeta()
    return { catalogWideMetaTitle }
  },
  computed: {
    ...mapGetters('settings', ['layout']),
    pageContent() {
      return this.$route.query.preview
        ? this.page?.temporaryContent
        : this.page?.content
    },
  },
  async asyncData({ $axios, $bugsnag, redirect, store }) {
    const url = `/ca/${store.state.settings.school}/catalogPages/${
      store.state.settings.activeCatalog
    }/programs`

    try {
      const [page, { terms }, { semesterNames }] = await Promise.all([
        $axios.$get(url),
        $axios.$get(`/${store.state.settings.school}/general/terms`),
        $axios.$get(`/${store.state.settings.school}/general/semesterNames`),
      ])
      return {
        page,
        terms,
        semesterNames,
      }
    } catch (e) {
      // 404 status (with {} response body) is an expected response here, if the programs pre-built page is not present in the catalog
      // (this page can be removed from catalog)
      // we don't want to pollute bugsnag with those errors
      if (e.response.status !== 404) {
        $bugsnag.notify(e)
      }
      return {
        page: null,
        terms: [],
        semesterNames: {},
      }
    }
  },
  head() {
    return {
      ...metaTitle(this.page?.metafields, this.catalogWideMetaTitle),
      meta: metaTags(this.page?.metafields),
    }
  },
  provide() {
    return {
      terms: this.terms,
      semesterNames: this.semesterNames,
    }
  },
}
</script>

<style lang="css" scoped>
.search-wrapper /deep/ .card {
  display: flex !important;
  margin-bottom: 0;
}

@screen md {
  .programs-list {
    column-count: 2;
  }
}
</style>
